import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

const MOBILE_ALLOWED = [
  '/calc',
  '/business-details',
  '/config',
  '/inventory',
  '/dashboard',
  '/manufacturing',
  '/costing',
  '/reports',
];

@Injectable({ providedIn: 'root' })
export class MobileGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const isMobile = window.innerWidth < 768;
    if (!isMobile) return true;

    if (MOBILE_ALLOWED.some(p => state.url.startsWith(p))) return true;

    this.router.navigate(['/calc']);
    return false;
  }
}
